var t={City:"City",CityWithSpecialStatus:"CityWithSpecialStatus",UrbanTypeSettlement:"UrbanTypeSettlement",Village:"Village",RuralSettlement:"RuralSettlement"};export{t as SettlementTypeValues};
//# sourceMappingURL=SettlementType.js.map